import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { InvoiceDetailPanel } from "../InvoiceDetailPanel";
import { ExpandableDetailDialog } from "./ExpandableDetailDialog";

type InvoiceDetailModalProps = {
  invoiceId: string | null;
  opened: boolean;
  onClose: () => void;
  onCustomerClick?: (customerId: number) => void;
};

export function InvoiceDetailModal({
  invoiceId,
  opened,
  onClose,
  onCustomerClick,
}: InvoiceDetailModalProps) {
  const navigate = useNavigate();
  const discardGuardRef = useRef<(() => boolean) | null>(null);

  const requestClose = () => {
    if (discardGuardRef.current && !discardGuardRef.current()) return;
    onClose();
  };

  const handleCustomerClick = (customerId: number) => {
    if (discardGuardRef.current && !discardGuardRef.current()) {
      return;
    }
    if (onCustomerClick) {
      onClose();
      onCustomerClick(customerId);
      return;
    }
    onClose();
    navigate(`/customers/${customerId}`);
  };

  return (
    <ExpandableDetailDialog
      opened={opened && Boolean(invoiceId)}
      title={invoiceId ? `Invoice ${invoiceId}` : "Invoice"}
      titleId="invoice-detail-title"
      closeAriaLabel="Close invoice"
      resetKey={invoiceId}
      onClose={requestClose}
    >
      {invoiceId ? (
        <InvoiceDetailPanel
          invoiceId={invoiceId}
          embedded
          navigateOnSendSuccess={false}
          discardGuardRef={discardGuardRef}
          onCustomerClick={handleCustomerClick}
        />
      ) : null}
    </ExpandableDetailDialog>
  );
}
